import { useNavigate } from "react-router-dom";
import { App, markedApplications } from "../applications.ts";
import { useFetch } from "../useFetch.ts";
import { HealthCheckResponse, VersionInfoResponse } from "./Application.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { JSX } from "react";

function AppTableRow(app: App) {
  const key = app.appId();
  const navigate = useNavigate();

  const { data } = useFetch<VersionInfoResponse>(app.hostname, "/q/info");
  const { data: healthCheckData } = useFetch<HealthCheckResponse>(
    app.hostname,
    "/q/health"
  );

  const handleRowClick = () => {
    navigate(`/apps/${key}/logs`);
  };

  const getStatusIcon = (status?: string): JSX.Element => {
    if (!status)
      return (
        <FontAwesomeIcon icon={faQuestionCircle} className="text-secondary" />
      );

    switch (status.toUpperCase()) {
      case "UP":
        return (
          <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
        );
      case "DOWN":
        return <FontAwesomeIcon icon={faTimesCircle} className="text-danger" />;
      default:
        return (
          <FontAwesomeIcon icon={faQuestionCircle} className="text-warning" />
        );
    }
  };

  return (
    <tr
      key={key}
      onClick={handleRowClick}
      className="cursor-pointer"
      style={{ cursor: "pointer" }}
    >
      <td>
        {app.name} {app.slot == "staging" ? " staging" : ""}
      </td>
      <td>{data?.build.version || "N/A"}</td>
      <td>
        <span className="d-flex align-items-center">
          {getStatusIcon(healthCheckData?.status)}
        </span>
      </td>
    </tr>
  );
}

export default function Root() {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>Navn</th>
            <th>Siste Snapshot</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>{markedApplications.map((app) => AppTableRow(app))}</tbody>
      </table>
    </div>
  );
}
